import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
const GET_MESSENGER_CONNECTIONS = 'GET_MESSENGER_CONNECTIONS';
export const GetMessengerConnectionsActionTypes = createAsyncActionTypes(GET_MESSENGER_CONNECTIONS);